import { inject } from 'vue'

const useInjectedStore = (symbol) => {
  const useStore = inject(symbol, null)
  return useStore?.()
}

export const customerAccountInjectionKey = 'stores.customerAccount'
export const useCustomerAccountStore = () => useInjectedStore(customerAccountInjectionKey)

export const contextConfigurationInjectionKey = 'stores.contextConfiguration'
export const useContextConfigurationStore = () => useInjectedStore(contextConfigurationInjectionKey)

export const masterdataInjectionKey = 'stores.masterdata'
export const useMasterdataStore = () => useInjectedStore(masterdataInjectionKey)

export const provideCommonStores = (app, storeProviders) => {
  if (!storeProviders) {
    return
  }
  Object.entries(storeProviders)
    .forEach(([storeName, provider]) => {
      if (!(provider instanceof Function)) {
        console.warn(`"${storeName}" store provider is not of required type: Function. This store will not be used`)
        return
      }
      app.provide(storeName, provider)
    })
}
